import { useState, useEffect } from "react"
import { useGlobalContext } from "../../data/GlobalContext"

export default function GameHistory() {
  const { fetchGamingReport, fetchGamingReportDetails, username } =
    useGlobalContext()
  const getToday = () => new Date().toISOString().split("T")[0]
  const [fromDate, setFromDate] = useState(getToday())
  const [toDate, setToDate] = useState(getToday())

  const [gameReport, setGameReport] = useState([])
  const [reportDetails, setReportDetails] = useState([])
  const [loadingDetails, setLoadingDetails] = useState(false)

  // Fetch the summary gaming report for the provided date range.
  const handleFilter = async () => {
    if (!username) {
      alert("Username is missing.")
      return
    }
    try {
      const report = await fetchGamingReport(username, fromDate, toDate)
      setGameReport(report)
    } catch (error) {
      console.error("Error fetching summary report:", error)
    }
  }

  // Fetch the detailed gaming report data.
  const handleViewDetails = async () => {
    if (!username) {
      alert("Username is missing.")
      return
    }
    setLoadingDetails(true)
    try {
      console.log("Fetching details with:", { username, fromDate, toDate })
      const details = await fetchGamingReportDetails(username, fromDate, toDate)
      console.log("Details fetched:", details)
      setReportDetails(details)
    } catch (error) {
      console.error("Error fetching details:", error)
    } finally {
      setLoadingDetails(false)
    }
  }

  // Automatically load the default one-week summary when username is available.
  useEffect(() => {
    if (username) {
      handleFilter()
    }
  }, [username, fromDate, toDate])

  return (
    <div className="game-report-container">
      <span>Game Report</span>
      <div className="transaction-report-tools">
        <div className="transaction-report-datepicker">
          <label>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="data-datepicker"
          />
        </div>
        <div className="transaction-report-datepicker">
          <label>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="data-datepicker"
          />
        </div>
        <button
          onClick={handleFilter}
          className="transaction-report-filter-btn"
        >
          Continue
        </button>
      </div>
      <div className="game-report-wrapper">
        <div className="game-report-table">
          <div className="game-report-head">
            <div>Total Turnover</div>
            <div>Win/Loss</div>
            <div>Details</div>
          </div>
          <div className="game-report-body">
            {gameReport.length > 0 ? (
              gameReport.map((tx, index) => (
                <div key={index} className="game-report-results">
                  <div>{tx.turnover || "-"}</div>
                  <div>{tx.winLoss || "-"}</div>
                  <div>
                    <button onClick={handleViewDetails}>View Details</button>
                  </div>
                </div>
              ))
            ) : (
              <div className="game-report-error-message">
                No data available for the selected period.
              </div>
            )}
          </div>
          {reportDetails && reportDetails.length > 0 && (
            <div className="report-details" style={{ marginTop: "20px" }}>
              <div className="game-report-table">
                <div className="game-report-head">
                  <div>Game</div>
                  <div>Turnover</div>
                  <div>Win/Loss</div>
                </div>
                <div className="game-report-body">
                  {reportDetails.map((detail, index) => (
                    <div key={index} className="game-report-results">
                      <div>{detail.Game}</div>
                      <div>{detail.Turnover}</div>
                      <div>{detail.Winloss}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {fromDate === "" && toDate === "" && (
        <div className="game-report-disclaimer-message">
          ( Data's from about a week ago—pick a date to see more )
        </div>
      )}
    </div>
  )
}
